<template>
    <v-container id="home" class="fill-height">
        <!-- <TheNavigationPanel/> -->
        <v-snackbar v-model="snackbar" :timeout="10000" top color="red">
            <span>Sign Up Not Successful</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbar1" :timeout="10000" top color="red">
            <span>User Already Exists</span> 
            <v-btn text color="white" @click="snackbar1 = false">Close</v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbar2" :timeout="10000" top color="red">
            <span>Password and Confirm Password Must Match!</span> 
            <v-btn text color="white" @click="snackbar2 = false">Close</v-btn>
        </v-snackbar>
        <v-row justify-center align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
                <v-card class="pa-10 mx-auto mt-8" id="login" max-width="500px" elevation="7">
                    <h3 class="text-center" style="color:#1a00d4">SIGN UP</h3>
                    <v-card-text>
                        <v-form ref="form">
                            <v-text-field outlined dense label="Email"  prepend-inner-icon="mdi-account" name="email" v-model="email" type="text" color="#1a00d4" :rules="emailRules"></v-text-field>
                            <v-text-field outlined dense class="" label="Username"  prepend-inner-icon="mdi-account" name="username" v-model="username" type="text" color="#1a00d4" :rules="usernameRules">

                            </v-text-field>
                            <v-text-field outlined dense class="" label="Password" name="password" v-model="password"
                                :append-icon="show1 ? 'visibility' : 'visibility_off'" color="#1a00d4"
                                :type="show1 ? 'text' : 'password'"
                                @click:append="show1 = !show1"
                                prepend-inner-icon="mdi-lock"
                                :rules="passwordRules"
                              >
                            </v-text-field>
                            <v-text-field outlined dense class="" label="Confirm Password" name="confirmpassword" v-model="confirmPassword"
                                :append-icon="show2 ? 'visibility' : 'visibility_off'" color="#1a00d4"
                                :type="show2 ? 'text' : 'password'"
                                @click:append="show2 = !show2"
                                prepend-inner-icon="mdi-lock"
                                :rules="confirmPasswordRules"
                              >
                            </v-text-field>
                        
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <div class="mx-auto mt-4">
                        <v-btn large dark color="#1a00d4" :loading="loading" class="text-none ml-2 font-weight-bold title mt-n9" v-on:click="signup()">
                            Sign Up
                        <v-icon right>mdi-login</v-icon>
                        </v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" width="500" persistent >
            <v-card class="pa-9 mx-auto" id="login" max-width="500" elevation="7">
                <div class="text-center mt-5 mb-4 font-weight-bold" style="color:#1a00d4; font-size:16px">Almost There...</div>
                <v-card-text class="black--text" style="font-size:14px">
                    Please check your email <b>({{email}})</b> to confirm your account
                </v-card-text>
                <v-divider></v-divider>
                <br>
                <v-card-text class="black--text" style="font-size:14px">
                    If <b> {{email}}</b> is not your email address<br>
                    Please signup again <br><br>
                    If you haven't received email in 15mins<br>
                    Please check your spam folder<br><br>
                    Still can't find it? Try searching Gmail for "in:all<br>
                    subject:(Bitshopy)""
                </v-card-text>
                <v-card-text class="text-right" >
                    <v-btn dark color="#1a00d4" class="text-none font-weight-bold title mt-12" router-link to="/home">
                        Ok
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
// import TheNavigationPanel from '../components/TheNavigationPanel';
export default {
    components:{
        // TheNavigationPanel
    },
    name:'SignUp',
    data(){
        return{
            username:"",
            password:"",
            confirmPassword:"",
            email:"",
            show1: false,
            show2: false,
            loading: false,
            snackbar:false,
            snackbar1:false,
            snackbar2:false,
            dialog:false,
            emailRules:[v => !!v || 'Email is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid',
            ],
            usernameRules:[v => !!v || 'Username is required'],
            passwordRules: [v => !!v || 'Password is required',
                v => v.length > 5 || 'Password must not be less than 6 characters'
            ],
            confirmPasswordRules: [v => !!v || 'Confirm Password is required',
                v => v.length > 5 || 'Confirm Password must not be less than 6 characters'
            ]

        }
    },
    methods:{
        signup(){
        if (this.$refs.form.validate()){
            if(this.password===this.confirmPassword){
                this.loading = true
                this.$store.dispatch("Register", {
                "username": this.username,
                "password": this.password,
                "email": this.email
                })
                .then(()=>{
                this.loading = false
                this.dialog = true
                })
                .catch((error)=>{
                    if(error.response.status===400){
                        this.snackbar1 = true
                        this.loading = false
                    }else{
                        this.snackbar = true
                        this.loading = false
                    }
                });
            }else{
                this.snackbar2 = true
            }
            
        }
      }

    }
}
</script>
<style  scoped>
    #home{
        background: url('/mainBackground.png');
        background-size: cover;
        width: 100%;
        height: 100%;
    }
    
    #login{
        border-radius: 5px;
    }
    .forgot{
        text-transform: capitalize;
    }
</style>